import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=95c72c8a"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports